<script lang="ts" setup>
import { Assignment } from "classes/models/assignments/assignment.model";

const props = defineProps({
  filteredAssignments: {
    type: Array as PropType<Assignment[]>,
    required: true,
  },
});

const classroomsDataStore = useUserClassroomsDataStore();
const { activeAssignments, classrooms, otherUserClassrooms } =
  storeToRefs(classroomsDataStore);

const appUserDataStore = useAppUserData();
const { showOtherUsersClassrooms } = storeToRefs(appUserDataStore);

const classroomName = computed(() => {
  return (assignment: Assignment) => {
    const classroom = classrooms.value.find(
      (classroom) => classroom.id == assignment.classroomId
    );

    return classroom?.label ?? assignment.classroomName;
  };
});

const filteredAssignments = computed(() => {
  if (showOtherUsersClassrooms.value == true) {
    return activeAssignments.value;
  }

  var otherUserClassroomIds = otherUserClassrooms.value.map(
    (classroom) => classroom.id
  );

  return activeAssignments.value.filter((assignment) => {
    return otherUserClassroomIds.includes(assignment.classroomId) != true;
  });
});

const showSummary = ref(true);

const sortDirection = ref<"asc" | "desc">("desc");

const toggleDirection = () => {
  sortDirection.value = sortDirection.value == "asc" ? "desc" : "asc";
};

const sortedAssignments = computed(() => {
  if (sortDirection.value == "desc") return filteredAssignments.value;

  var copy = [...filteredAssignments.value];

  return copy.reverse();
});
</script>

<template>
  <div class="flex flex-col min-h-0 h-full p-2">
    <div
      class="flex flex-row items-center justify-between pt-4 border-b pb-2 pl-2"
    >
      <h2 class="text-h5 font-bold">Assignment Progress</h2>
      <BaseIconButton @click="toggleDirection" :size="35">
        <BaseIconSortDesc v-if="sortDirection == 'desc'" size="35" />
        <BaseIconSortAsc v-if="sortDirection == 'asc'" size="35" />
      </BaseIconButton>
    </div>
    <div class="flex flex-col h-full overflow-auto grow pt-2" v-auto-animate>
      <div
        v-for="assignment in sortedAssignments"
        :key="assignment.id"
        class="flex flex-col border-b last:border-b-0 mb-2 pb-2 w-full"
      >
        <div class="hover:bg-light-default p-2 rounded overflow-hidden text-ellipsis flex flex-col">
          <span class="whitespace-nowrap text-body-1 text-ellipsis w-full overflow-hidden">
            {{ classroomName(assignment) }} - {{ assignment.name }}
          </span>
          <ClassroomAssignmentProgress
            :classroom-id="assignment.classroomId"
            :assignment-id="assignment.id!"
            class="max-w-[400px]"
            :always-show="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
